// extracted by mini-css-extract-plugin
export default {"container":"Companies_container__hrFV+"};